import React from 'react';
import './IndividualPerformance.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import ReactApexChart from 'react-apexcharts';
import { useLocation } from 'react-router-dom';

const IndividualPerformance = () => {
    const location = useLocation();
//   const navigate = useNavigate();
  const userDetails = location.state?.userDetails || null;

    const state = {
        series: [{
          data: [10, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 90],
          color:'#173452',
        }],
        options: { 
          chart: {
            type: 'bar',
            height: 400,
          },
          plotOptions: {
            bar: {
              borderRadius: 2,
              horizontal: false,
            }
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
          }
        },
      };

return( 
    <div>
        <SideMenuBar></SideMenuBar>
                
        <div class="content">
            <NewHeader></NewHeader>
                
            <div className='row2'>
                <h3 className='name_IndividualPerformance'>{userDetails.username} &nbsp;&nbsp;&nbsp;</h3>  
            </div>

            <div class="row3_IndividualPerformance">
                <div class="column1_row3_IndividualPerformance">
                    <div className='whiteBox_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Select Date</p>
                        <input type="date" id="date" name="date" className='date_whiteBox_IndividualPerformance'/>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Total Present Days</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>{userDetails.total_present_days_count || 0}</b></p>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Over-time Hours</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                </div>
  
                <div class="column2_row3_IndividualPerformance">
                    <div className='whiteBox_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Tasks Completed</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Total Absent Days</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>{userDetails.total_absent_days_count || 0}</b></p>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Total Sites Completed</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                </div>
  
                <div class="column3_row3_IndividualPerformance">
                    <div className='whiteBox_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Tasks Incompleted</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Total Half-day Leaves</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                    <div className='whiteBox2_IndividualPerformance'>
                        <p className='title_whiteBox_IndividualPerformance'>Total Distance Travelled</p>
                        <p className='data_whiteBox_IndividualPerformance'><b>$123</b></p>
                    </div>
                </div>
  
                <div class="column4_row3_IndividualPerformance">
                    <div className='whiteBox4_IndividualPerformance'>
                        <p className='title_whiteBox4_IndividualPerformance'>Personal Information</p>
                        <p className='txt_whiteBox4_IndividualPerformance'>Name : <b>{userDetails.username || "not avalible"}</b></p>
                        <p className='txt_whiteBox4_IndividualPerformance'>Role : <b>{userDetails.role || "not avalible"}</b></p>
                        <p className='txt_whiteBox4_IndividualPerformance'>Phone no. : <b>{userDetails.mobile || "not avalible"}</b></p>
                        <p className='txt_whiteBox4_IndividualPerformance'>Email ID : <b>{userDetails.email || "not avalible"}</b></p>
                        <p className='txt_whiteBox4_IndividualPerformance'>Address : <b>{userDetails.address || "not avalible"}</b></p>
                        <div className='pos_clickHere'>
                            <a href='/' className='aOf_whiteBox4_IndividualPerformance'><b>Click here to view location history</b></a>
                        </div><br/>

                    </div>
                </div>
            </div>

            <div class="row4_IndividualPerformance">
                <ReactApexChart options={state.options} series={state.series} type="bar" height={'102%'}/>
            </div>



        </div>
</div>
 )
}

export default IndividualPerformance;